
        <div class="col-lg-6 col-md-8 col-xs-12">
            <p style='color: #919191;'>Sync Settings</p>
            <div class="customHr" style="width:150px">.</div>
            <form [formGroup]="form" novalid>
                    <div class="row">
                        <div class="col-md-6 col-xs-12" style="margin-bottom: 0px;padding-left:0px!important;">
                            <div class="form-group">
                                <p class="custom-label">Sync Cron Job</p>
                                <input style="margin-bottom: 5px;" type="text" [(ngModel)]="data.syncCrunJob" formControlName="syncCrunJob" class="form-control" placeholder="Sync Cron Job" title="Sync Cron Job">
                                <a href="https://crontab.guru" target="_blank">Generate Here</a>
                            </div>
                        </div>
                    </div>
            </form>

            <p style='color: #919191; margin-top: 20px'>Sync Status</p>
            <div class="customHr" style="width:140px">.</div>

            <p>Number of Students: {{data.studentCount}}</p>
            <p>Number of Students Contacts: {{data.studentContactCount}}</p>
            <p>Number of Organization: {{data.organizationCount}}</p>
            <p>Last Sync At: {{printDate(data.lastSyncedAt)}}</p>
            <p>Sync Error: {{data.lastSyncError != "" ? data.lastSyncError : 'No errors'}}</p>
				<p>Last Sync Error At: {{printDate(data.lastSyncErrorAt)}}</p>
            <p>Sync Status: {{syncStatusTitle}}</p>

            <div class="row mt2">
                <button [disabled]="!showSaveButton" type="button" class="btn btn-large btn-primary" (click)="save()">{{ saveTitle }}</button>
                <a type="button" class="btn btn-large btn-deny" style="margin-left:10px; cursor: pointer;" (click)="refresh()">Refresh</a>
                <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
            </div>

            <div class="row mt2" [hidden]="msg.msg == ''">
                <alert [alert]="msg"></alert>
            </div>
        </div>
    